/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespBrowseHeader_itemSearch$ref = any;
type SbRespContentModuleSelector_itemSearch$ref = any;
type SbRespPageSize_itemSearch$ref = any;
type SbRespRefineMenuSelector_itemSearch$ref = any;
type SbRespSearchResultContainer_itemSearch$ref = any;
type SbRespSortItems_itemSearch$ref = any;
type SbSharedRelatedItems_itemSearch$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespMainContent_itemSearch$ref = any;
export type SbRespMainContent_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly displayUriRef: string | null;
    readonly displayMaxNumberOfPages: number | null;
    readonly " $fragmentRefs": SbRespRefineMenuSelector_itemSearch$ref & SbRespContentModuleSelector_itemSearch$ref & SbRespSortItems_itemSearch$ref & SbRespPageSize_itemSearch$ref & SbRespBrowseHeader_itemSearch$ref & SbRespSearchResultContainer_itemSearch$ref & SbSharedRelatedItems_itemSearch$ref;
    readonly " $refType": SbRespMainContent_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespMainContent_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayMaxNumberOfPages",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleSelector_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespPageSize_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespBrowseHeader_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '72ec76278eed1481f601b1a35a369424';
export default node;
